import { IcChevR, IcSearch } from './icons';
import { INSIGHTS, SUGGEST_TILES } from './constants';
import { IMode, FormType, getGreeting } from './types';

interface Props {
	firstName: string;
	onSuggestion: (prompt: string, mode: IMode, formType?: FormType) => void;
	dynamicQuestions?: any[];
	mode: IMode;
}

const ChatBotWelcome = ({ firstName, onSuggestion, dynamicQuestions = [], mode }: Props) => {
	const greeting = getGreeting();

	const dynamicTiles = dynamicQuestions.map(dq => ({
		icon: IcSearch,
		kind: dq.kind || 'blue',
		cat: dq.cat,
		mode: dq.mode,
		formType: dq.formType,
		prompt: dq.prompt
	}));

	const askTiles = dynamicQuestions.length > 0 ? dynamicTiles : SUGGEST_TILES.filter(t => t.cat === 'ASK');
	const agentTiles = SUGGEST_TILES.filter(t => t.cat === 'AGENT');
	const docTiles = SUGGEST_TILES.filter(t => t.cat === 'DOC');
	const displayTiles = mode === 'conversation' ? askTiles : mode === 'agent' ? agentTiles : docTiles;

	return (
		<div className='chatBot--welcome'>
			<div className='chatBot--greeting'>
				{greeting}
				{firstName && (
					<>, <span className='chatBot--grad'>{firstName}</span></>
				)}
			</div>
			<div className='chatBot--greeting-sub'>
				NovaForce is watching your ERP data. Here's what stands out today.
			</div>

			{/* Insights section is removed as per latest design, but can be added back if needed in the future */}
			{/* <div className='chatBot--section-lbl'>
				<span>Insights for you</span>
				<span className='chatBot--ln' />
			</div>

			<div className='chatBot--insight-list'>
				{INSIGHTS.map((item, i) => (
					<div className='chatBot--insight-row' key={i}>
						<span className={`chatBot--ic chatBot--ic--${item.kind}`}>
							<item.icon size={13} />
						</span>
						<div className='chatBot--ins-body'>
							<div className='chatBot--ins-title'>{item.title}</div>
							<div className='chatBot--ins-sub'>{item.sub}</div>
						</div>
						<div className='chatBot--ins-chevron'>
							<IcChevR size={13} />
						</div>
					</div>
				))}
			</div> */}

			<div className='chatBot--section-lbl'>
				<span>Try asking</span>
				<span className='chatBot--ln' />
			</div>

			<div className='chatBot--suggest-grid'>
				{displayTiles.map((tile, i) => (
					<button
						key={i}
						className='chatBot--suggest-tile'
						onClick={() => onSuggestion(tile.prompt, tile.mode as IMode, tile.formType as FormType)}>
						<div className='chatBot--suggest-head'>
							<span className={`chatBot--ic chatBot--ic--${tile.kind}`}>
								<tile.icon size={13} />
							</span>
							<span className='chatBot--suggest-cat'>{tile.cat}</span>
						</div>
						<div className='chatBot--suggest-prompt'>{tile.prompt}</div>
					</button>
				))}
			</div>
		</div>
	);
};

export default ChatBotWelcome;
